export const useStyles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
  },
  paper: {
    padding: 30,
  },
  homeStyle: {
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
});
